import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DropdownMenuState } from 'src/components/GlobalPageV2/DropdownMenu/DropdownMenu.state';
import { useAppStateContext } from 'src/AppState/AppState';
import { CsvReadItem, PromotionQuestionsState } from 'src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import { ListItemComponent } from './ListItemComponent';

interface ListItemV2PropsType {
    title: string;
    active: boolean;
    question: CsvReadItem;
}
export interface DropdownItemType {
    label: string;
    onClick?: () => void;
}

const dropdownMenuItems = (
    setCurrentQuestion: (question: CsvReadItem) => void,
    question: CsvReadItem
): DropdownItemType[] => {
    return [
        {
            label: 'Edit',
            onClick: () => setCurrentQuestion(question),
        },
        // {
        //     label: 'Duplicate',
        // },
        // {
        //     label: 'Delete',
        // },
    ];
};

const handleChangeActive = async (
    promotionQuestionsState: PromotionQuestionsState,
    question: CsvReadItem
): Promise<void> => {
    // this.isLoading = true;
    // this.errorMessage = '';
    // this.form.setAsVisited();
    // const result = this.form.result;

    // if (result instanceof ResultValue) {
    const payload: Partial<CsvReadItem> = {
        id: question.id,
        name: question.name,
        active: !question.active,
        fileName: question.fileName,
        uploadedAt: question.uploadedAt,
        possibleAnswers: question.possibleAnswers,
        // ...this.questionFile, // fileName, up§loadedAt, possibleAnswers
    };

    const submitResult = await promotionQuestionsState.submitQuestion(payload);

    if (submitResult === null) {
        // this.promotionQuestionsState.setCurrentQuestion(null);
        // this.promotionQuestionsState.setRecentlyUpdatedQuestion(submitResult);
        // this.form.reset();
        // this.errorMessage = 'Unknown error. Something went wrong.';
    } else {
        await promotionQuestionsState.refreshQuestions();
    }
    // }
    // this.isLoading = false;
};

export const ListItem = observer((props: ListItemV2PropsType) => {
    const { title, active, question } = props;
    const [dropdownState] = useState(() => new DropdownMenuState());
    const { promotionQuestionsState } = useAppStateContext();
    const { setCurrentQuestion } = promotionQuestionsState;

    const dropdownItemsForView = dropdownMenuItems(setCurrentQuestion, question);
    const publishQuestion = async (): Promise<void> => {
        await handleChangeActive(promotionQuestionsState, question);
    };

    return (
        <ListItemComponent
            title={title}
            active={active}
            switchOnChange={publishQuestion}
            dropdownState={dropdownState}
            dropdownItemsForView={dropdownItemsForView}
        />
    );
});
